module.exports = __webpack_public_path__ + "static/img/historyTrack.1ff0c95d.svg";